<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Use global element
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-global-element block="text" :locale="locale" v-model="element.object.global.enabled" @onGetValues="setGlobalValues" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Copy
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-cmp-trix-field
                            :classes="{ wrapper: { 'reset': true } }"
                            v-model="element.object.values.copy"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Align
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-fancy-option
                            class="reset"
                            :data="alignOptions"
                            v-model="element.object.values.align"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import ComposerTrixField from '@/components/composer/Fields/Trix';
    import fancyOptionField from '@/components/fields/inputs/FancyOption';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import GlobalField from '@/components/composer/Fields/Global';
    import GlobalMixin from '@/components/composer/Mixins/Global';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-trix-field': ComposerTrixField,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-fancy-option': fancyOptionField,
            'app-global-element': GlobalField

        },
        mixins: [ GlobalMixin ],
        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            }
        },
        data: () => ({
            fields: {
                copy: {
                    name: 'Copy',
                    attribute: 'copy'
                },
                align: {
                    name: 'Align',
                    attribute: 'align'
                },
            },
            alignOptions: [
                {
                    value: 'left',
                    icon: 'align-left'
                },
                {
                    value: 'center',
                    icon: 'align-center'
                },
                {
                    value: 'right',
                    icon: 'align-right'
                },
                {
                    value: 'justify',
                    icon: 'align-justify'
                }
            ],
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/TextSettings.vue